import { Route, Routes } from "react-router-dom";
import AboutUs from "./components/AboutUs";
import AdminRoute from "./components/AdminRoute";
import ConditionalLayout from "./components/ConditionalLayout";
import RouteGuard from "./components/RouteGuard";
import SimpleUploadTest from "./components/SimpleUploadTest";
import TermsAndPolicies from "./components/TermsAndPolicies";
import { AuthProvider } from "./contexts/AuthContext";
import AdminDashboard from "./pages/AdminDashboard";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import SigninPage from "./pages/auth/SigninPage";
import SignupPage from "./pages/auth/SignupPage";
import BooksMagazinesPage from "./pages/categories/BooksMagazinesPage";
import BusinessCardsPage from "./pages/categories/BusinessCardsPage";
import CustomizedStickersPage from "./pages/categories/CustomizedStickersPage";
import CustomStationaryPage from "./pages/categories/CustomStationaryPage";
import DiariesCalendarsPage from "./pages/categories/DiariesCalendarsPage";
import LabelsPackagingPage from "./pages/categories/LabelsPackagingPage";
import OfficeEssentialsPage from "./pages/categories/OfficeEssentialsPage";
import PostersMarketingPage from "./pages/categories/PostersMarketingPage";
import SignagePage from "./pages/categories/SignagePage";
import WeddingInvitesPage from "./pages/categories/WeddingInvitesPage";
import CategoryPage from "./pages/CategoryPage";
import SubcategoryPage from "./pages/SubcategoryPage";
import SubcategoryProductsPage from "./pages/SubcategoryProductsPage";
import CheckoutPage from "./pages/CheckoutPage";
import LandingPageV4 from "./pages/LandingPageV4";
import MyOrders from "./pages/MyOrders";
import OrderConfirmation from "./pages/OrderConfirmation";
import ProductPage from "./pages/ProductPage";
import TemplatesPage from "./pages/TemplatesPage";

function App() {
    return (
        <AuthProvider>
            <RouteGuard>
                <ConditionalLayout>
                    <Routes>
                        <Route path="/" element={<LandingPageV4 />} />

                        {/* Authentication Routes */}
                        <Route path="/signin" element={<SigninPage />} />
                        <Route path="/signup" element={<SignupPage />} />
                        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

                        {/* Admin Routes */}
                        <Route
                            path="/admin"
                            element={
                                <AdminRoute>
                                    <AdminDashboard />
                                </AdminRoute>
                            }
                        />

                        {/* Order Routes */}
                        <Route path="/orders/:orderId" element={<OrderConfirmation />} />
                        <Route path="/my-orders" element={<MyOrders />} />

                        {/* Checkout Route */}
                        <Route path="/checkout" element={<CheckoutPage />} />

                        {/* Test Routes - Development Only */}
                        <Route path="/test-upload" element={<SimpleUploadTest />} />

                        {/* Templates Route */}
                        <Route path="/templates" element={<TemplatesPage />} />

                        {/* Dynamic Routes */}
                        <Route path="/product/:id" element={<ProductPage />} />
                        <Route path="/subcategory/:category" element={<SubcategoryPage />} />
                        <Route path="/subcategory/:category/:subcategory" element={<SubcategoryProductsPage />} />
                        <Route path="/category/:category" element={<CategoryPage />} />

                        {/* Legacy Static Routes - can be removed once all links are updated */}
                        <Route path="/product" element={<ProductPage />} />
                        {/* <Route path="/categories/business-cards" element={<BusinessCardsPage />} />
                        <Route path="/categories/customized-stickers" element={<CustomizedStickersPage />} />
                        <Route path="/categories/wedding-invites" element={<WeddingInvitesPage />} />
                        <Route path="/categories/labels-packaging" element={<LabelsPackagingPage />} />
                        <Route path="/categories/posters-marketing" element={<PostersMarketingPage />} />
                        <Route path="/categories/custom-stationary" element={<CustomStationaryPage />} />
                        <Route path="/categories/office-essentials" element={<OfficeEssentialsPage />} />
                        <Route path="/categories/signage" element={<SignagePage />} />
                        <Route path="/categories/diaries-calendars" element={<DiariesCalendarsPage />} />
                        <Route path="/categories/books-magazines" element={<BooksMagazinesPage />} /> */}

                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/terms-and-policies" element={<TermsAndPolicies />} />
                    </Routes>
                </ConditionalLayout>
            </RouteGuard>
        </AuthProvider>
    );
}

export default App;
